import { gsap } from 'gsap';
import { runWhenPageReady } from '../utils/PageLifecycle';

/**
 * DashedBorderAnimation
 * 
 * Animates dashed borders to draw from left to right on page load
 * Targets header borders and main menu borders
 */
class DashedBorderAnimation {
  constructor() {
    this.init();
  }
  
  init() {
    // Target the main header
    const header = document.querySelector('.site-header');
    
    // Target the main menu overlay
    const menuOverlay = document.querySelector('.main-menu');
    
    if (!header && !menuOverlay) {
      console.log('DashedBorderAnimation: No header or menu found');
      return;
    }
    
    // Animate header border on page load (border already hidden via CSS)
    if (header) {
      this.animateBorder(header, 0.8, 0.2); // 800ms duration, 200ms delay
    }
    
    // Listen for menu open to animate menu border
    if (menuOverlay) {
      // Watch for menu toggle
      const menuToggle = document.querySelector('.menu-toggle');
      if (menuToggle) {
        menuToggle.addEventListener('click', () => {
          // Small delay to let menu start opening
          setTimeout(() => {
            if (menuOverlay.classList.contains('menu-active')) {
              this.animateBorder(menuOverlay, 0.6, 0);
            }
          }, 100);
        });
      }
    }
  }
  
  /**
   * Animate border by creating an overlay with dashed border that reveals from left to right
   */
  animateBorder(element, duration, delay) {
    console.log('Animating border for:', element);
    
    // Note: border is already hidden in init()
    
    // Create overlay element for the animated border - full width
    const borderOverlay = document.createElement('div');
    borderOverlay.style.position = 'absolute';
    borderOverlay.style.bottom = '-1px';
    borderOverlay.style.left = '0';
    borderOverlay.style.width = '100%';
    borderOverlay.style.height = '1px';
    borderOverlay.style.pointerEvents = 'none';
    borderOverlay.style.zIndex = '1001';
    
    // Apply the dashed border pattern matching the header
    const borderColor = element.classList.contains('header-light') ? '#C7CCB6' : '#5D6259';
    borderOverlay.style.borderBottom = '1px solid transparent';
    borderOverlay.style.borderImage = `repeating-linear-gradient(90deg, ${borderColor} 0 16px, transparent 16px 26px) 1`;
    
    // Use clip-path to reveal from left to right
    borderOverlay.style.clipPath = 'inset(0 100% 0 0)';
    
    console.log('Border overlay created with color:', borderColor);
    
    // Ensure element has position context
    const originalPosition = window.getComputedStyle(element).position;
    if (originalPosition === 'static') {
      element.style.position = 'relative';
    }
    
    element.appendChild(borderOverlay);
    
    // Animate the clip-path to reveal the border from left to right
    gsap.to(borderOverlay, {
      clipPath: 'inset(0 0% 0 0)',
      duration: duration,
      delay: delay,
      ease: 'power2.out',
      onComplete: () => {
        console.log('Animation complete - border overlay stays in place');
        // Keep the overlay as the permanent border replacement
      }
    });
  }
}

/**
 * Initialize dashed border animation on page load
 */
function initDashedBorderAnimation() {
  new DashedBorderAnimation();
}

runWhenPageReady(initDashedBorderAnimation);

export default DashedBorderAnimation;
